import { Sparkles } from "lucide-react";

export default function DemoNotice({
  variant = "light",
  label = "Sample HVAC site — built by PrismForge Digital",
  className = "",
}) {
  const isLight = variant === "light";
  return (
    <span
      data-testid="demo-notice"
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium ${
        isLight
          ? "border border-white/15 bg-white/10 text-white/85 backdrop-blur"
          : "border border-navy/10 bg-white text-navy/70 shadow-soft"
      } ${className}`}
    >
      <Sparkles
        className={`h-3 w-3 ${isLight ? "text-sun" : "text-aqua"}`}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}
